/* tslint:disable */
/* eslint-disable */
/**
 * Property Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.0.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TenantBase
 */
export interface TenantBase {
    /**
     * 
     * @type {string}
     * @memberof TenantBase
     */
    name: string;
}

export function TenantBaseFromJSON(json: any): TenantBase {
    return TenantBaseFromJSONTyped(json, false);
}

export function TenantBaseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TenantBase {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
    };
}

export function TenantBaseToJSON(value?: TenantBase | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
    };
}


